var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 249,
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 124.5,
    r: 124.5,
    fill: "#34737A",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.129,
    cy: 123.87,
    r: 87.4015,
    fill: "#34737A",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.129,
    cy: 123.871,
    r: 54.7045,
    fill: "#34737A",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.319 121.124V124.501C136.319 131.029 131.027 136.32 124.5 136.32M112.681 121.124V124.501C112.681 131.029 117.973 136.32 124.5 136.32M124.5 136.32V141.385M117.746 141.385H131.254M124.5 129.567C121.703 129.567 119.435 127.299 119.435 124.501V112.682C119.435 109.885 121.703 107.617 124.5 107.617C127.297 107.617 129.565 109.885 129.565 112.682V124.501C129.565 127.299 127.297 129.567 124.5 129.567Z",
    stroke: "#19535A",
    strokeWidth: 3.37682,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikeIcon);
export default __webpack_public_path__ + "static/media/mikeIcon.43dbbe537b4092a54391511d9671f539.svg";
export { ForwardRef as ReactComponent };